/**
 * A reusable spinner component that can be used to indicate loading states.
 * The spinner can be customized with different sizes and colors.
 */

interface Props {
  center?: boolean;
  small?: boolean;
  white?: boolean;
}

const Spinner = ({ center = false, small = false, white = false }: Props) => (
  <div className={`spinner ${center ? 'center' : ''}`} />
);

export default Spinner;
